import React from "react";
import WavyText from "./WavyText";

const AnimatedHeading = ({
  as: Tag = "h2",
  text,
  parts,
  className = "",
  delayOffset = 0.04,
}) => {
  // Render single string or multiple parts with optional line breaks between
  return (
    <Tag className={className}>
      {Array.isArray(parts) && parts.length > 0 ? (
        parts.map((part, idx) => (
          <React.Fragment key={idx}>
            <WavyText text={part} delayOffset={delayOffset} />
            {idx < parts.length - 1 && <br className="hidden md:block" />}
          </React.Fragment>
        ))
      ) : (
        <WavyText text={text || ""} delayOffset={delayOffset} />
      )}
    </Tag>
  );
};

export default AnimatedHeading;
